const isDebugEnabled = () => {
  if (typeof window !== 'undefined' && window.PEPAY_DEBUG) {
    return true;
  }

  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_PEPAY_DEBUG === 'true') {
    return true;
  }

  return false;
};

const debugLog = (...args) => {
  if (!isDebugEnabled()) {
    return;
  }

  // eslint-disable-next-line no-console
  console.log(...args);
};

export default debugLog;
